import { useEffect, useState } from "react";
import { GoldDots } from "@/components/Brand";
import { formatDate, useApi } from "@/lib/api";
import { Panel, Row } from "@/components/admin/AdminUI";

const LABELS = {
  sign_in: "Sign-in", role_change: "Role change", plans_access: "Plan access", safety_alert: "Safety alert", sessions_revoked: "Sessions",
  account_suspended: "Suspended", account_restored: "Restored", account_deleted: "Account deleted", account_closed: "Account closed",
  retention_purge: "Retention", people_export: "Export", legacy_import: "Import", csv_export: "Export (go-native-2)",
  data_export: "Data export (go-native-2)", session_open: "Session (go-native-2)", session_close: "Session (go-native-2)",
};
const FILTERS = [["", "Everything"], ["sign_in", "Sign-ins"], ["role_change", "Roles"], ["plans_access", "Plan access"], ["account_deleted", "Deletions"], ["legacy_import", "Imports"]];

export const AdminAudit = () => {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [f, setF] = useState("");
  useEffect(() => { setRows(null); api.get("/admin/audit", { params: f ? { action: f } : {} }).then((r) => setRows(r.data)); }, [api, f]);
  return (
    <div className="space-y-5">
      <Panel title="Audit log" sub="A record of sign-ins and every admin action. The latest 300 entries are shown." testId="admin-audit">
        <div className="flex gap-2 overflow-x-auto pb-3 mb-2">
          {FILTERS.map(([k, l]) => (
            <button key={k || "all"} onClick={() => setF(k)} data-testid={`audit-filter-${k || "all"}`}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm border ${f === k ? "bg-charcoal border-charcoal text-alabaster" : "bg-white border-rule text-charcoal"}`}>{l}</button>
          ))}
        </div>
        {!rows ? <div className="py-10 flex justify-center"><GoldDots /></div> : rows.length === 0 ? <p className="text-ink-soft">Nothing recorded yet.</p> : (
          <ul data-testid="audit-list">
            {rows.map((r) => (
              <li key={r.id} className="py-3 border-b border-rule last:border-0 grid gap-1 sm:grid-cols-[150px_140px_1fr] sm:gap-4 text-sm">
                <span className="text-ink-soft">{formatDate(r.created_at, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
                <span className="font-medium text-charcoal">{LABELS[r.action] || r.action}</span>
                <span className="text-ink min-w-0 break-words">{r.detail}{r.actor_email && <span className="text-ink-soft"> · {r.actor_email}</span>}</span>
              </li>
            ))}
          </ul>
        )}
      </Panel>
      <Panel title="Governance" testId="admin-governance">
        <Row label="Plan privacy">Admins can't open or read anyone's Action Plan</Row>
        <Row label="Raw answers">Deleted 6 months after each plan is made</Row>
        <Row label="Closing an account">Personal data deleted; anonymised plan content kept</Row>
        <Row label="Consent">Terms and Privacy agreed at sign-up, with the date recorded</Row>
        <Row label="Safety">Crisis words alert {"support@teahusolutions.com"} for follow-up</Row>
      </Panel>
    </div>
  );
};
